export class Question {
    constructor({id, title, answers}) {
        this.id = id;
        this.title = title;
        this.answers = answers;
    };

    clone() {
        return new Question({
            id: this.id,
            title: this.title,
            answers: this.answers
        });
    };
}

export class Answer {
    constructor({id, label, selected}) {
        this.id = id;
        this.label = label;
        this.selected = selected;
    };

    select() {
        this.selected = true;
    };

    deselect() {
        this.selected = false;
    };

    clone() {
        return new Answer({
            id: this.id,
            label: this.label,
            selected: this.selected
        });
    };
}